import { createFeatureSelector, createSelector } from "@ngrx/store";

import { findVtoProductFromSku } from "../helpers/vto.helper";
import {
    LocalizedVtoSubcategory,
    NO_SELECT,
    NO_SHADE,
} from "../model/localized-vto-category.model";
import { VtoState } from "../reducers/vto-state";
import { vtoFeatureKey } from "../reducers/vto.reducer";

export const selectVtoState = createFeatureSelector<VtoState>(vtoFeatureKey);

export const selectVtoConfiguration = createSelector(
    selectVtoState,
    (featureState: VtoState) => featureState.vtoConfig,
);

export const selectIsApprovalState = createSelector(
    selectVtoState,
    (vtoState: VtoState) => vtoState.isApproval,
);

export const selectModalStatusState = createSelector(
    selectVtoState,
    (vtoState: VtoState) => vtoState.modalStatus,
);

export const selectCameraDimensionState = createSelector(
    selectVtoState,
    (vtoState: VtoState) => vtoState.cameraDimension,
);

export const selectSdkErrorState = createSelector(
    selectVtoState,
    (vtoState: VtoState) => vtoState.sdkError,
);

export const selectProductVtoType = createSelector(
    selectVtoState,
    (vtoState: VtoState) => vtoState.currentVtoType,
);

export const selectLocalizedVtoCategories = createSelector(
    selectVtoState,
    (vtoState: VtoState) => vtoState.localizedVtoCategories,
);

export const selectActiveCategory = createSelector(
    selectVtoState,
    (featureState: VtoState) => featureState.activeCategory,
);

export const selectActiveSubcategory = createSelector(
    selectVtoState,
    (featureState: VtoState) => featureState.activeSubcategory,
);

export const selectIsActiveSubcategoryProductSelected = createSelector(
    selectActiveSubcategory,
    (selectedActiveSubcategory: LocalizedVtoSubcategory) =>
        selectedActiveSubcategory.vtoProducts.some(
            (vtoProduct) =>
                vtoProduct.sku === selectedActiveSubcategory.selectedSkuVariant,
        ),
);

export const selectAppliedConfiguration = createSelector(
    selectVtoState,
    (vtoState: VtoState) => ({
        currentVtoSku: vtoState.currentVtoSku,
        skuApplied: vtoState.skuApplied,
    }),
);

export const selectDisplayLearnMoreLink = createSelector(
    selectVtoState,
    (featureState: VtoState) => featureState.displayLearnMoreLink,
);

export const selectVtoProductSelected = createSelector(
    selectVtoState,
    (vtoState: VtoState) =>
        findVtoProductFromSku(
            vtoState.currentVtoSku,
            vtoState.localizedVtoCategories,
        ),
);

export const selectVtoNoShadeOrNoSelect = createSelector(
    selectVtoState,
    (vtoState: VtoState) =>
        vtoState.activeSubcategory?.selectedSkuVariant === NO_SHADE ||
        vtoState.activeSubcategory?.selectedSkuVariant === NO_SELECT,
);

export const vtoModalConfiguration = createSelector(
    selectVtoState,
    (featureState: VtoState) => ({
        sdkError: featureState.sdkError,
        modalStatus: featureState.modalStatus,
        isApproval: featureState.isApproval,
    }),
);

export const selectPageType = createSelector(
    selectVtoState,
    (vtoState: VtoState) => vtoState.pageType,
);
